const copy = {
  "DonutBase": '',
  "CrullerBase": 'cruller',
  "JellyFilledBase": 'jelly_filled',
  "regular": 'regular',
  "chocolate": 'chocolate',
  "strawberry": 'strawberry',
  "PlainGlaze": 'plain_glaze',
  "ChocolateGlaze": 'chocolate_glaze',
  "StrawberryGlaze": 'strawberry_glaze',
  "MapleGlaze": 'maple_glaze',
  "BlueberryGlaze": 'blueberry_glaze',
  "PistachioGlaze": 'pistachio_glaze',
  "PowderedSugarTopping": 'powdered_sugar',
  "ChocolateSprinklesTopping": 'chocolate_sprinkles',
  "StrawberrySprinklesTopping": 'strawberry_sprinkles',
  "RainbowSprinklesTopping": 'rainbow_sprinkles',
  "HeartCandyTopping": 'heart_candy',
  "CerealTopping": 'cereal',
}

export default copy